import type { ErrorType } from '~/data/ErrorRecord';
import {
  UserListFields,
  defaultState as defaultUserListState,
} from './UsersList';
import {
  InvitesListFields,
  defaultState as defaultInviteListState,
} from './InvitesList';

export const defaultState: UserManagementFields = {
  isLoading: false,
  forceLoad: false,
  hasLoaded: false,
  isUserFullyNotFetchedModalOpen: false,
  userList: defaultUserListState,
  inviteList: defaultInviteListState,
  error: undefined,
};

export interface UserManagementFields {
  isLoading: boolean;
  forceLoad: boolean;
  hasLoaded: boolean;
  isUserFullyNotFetchedModalOpen: boolean;
  userList: UserListFields;
  inviteList: InvitesListFields;
  error?: ErrorType;
}
